var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"demo"}},[(_vm.theToast)?_c('div',{staticClass:"toast_wrap"},[_c('div',{staticClass:"toast"},[_vm._v(" "+_vm._s(_vm.msg)+" ")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }